// extracted by mini-css-extract-plugin
export default {"container":"components-GameStats-styles-module__container--F7ZRD"};